import { Helmet } from 'react-helmet-async';
import CircularProgress from '@mui/material/CircularProgress';
import { useState, useEffect, useCallback } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';

import {
  Table,
  Popover,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  TextField,
  InputAdornment,
  Grid,
  Tabs,
  Box,
  Tab,
  TableHead,
} from '@mui/material';
import { useTheme, styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { tableCellClasses } from '@mui/material/TableCell';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import { Dropdown, Space, Empty } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import SearchIcon from '@mui/icons-material/Search';
import Iconify from '../../components/iconify';
import Scrollbar from '../../components/scrollbar';
import { getToken } from '../../utils/common';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

// Helper function to get status background color
function getStatusBackgroundColor(status, theme) {
  const lowerStatus = status.toLowerCase();

  if (lowerStatus === 'open') {
    return theme.palette.error.main;
  }

  if (lowerStatus === 'process' || lowerStatus === 'inprogress') {
    return theme.palette.warning.main;
  }

  if (lowerStatus === 'pendingapproval') {
    return theme.palette.info.main;
  }

  if (lowerStatus === 'pendingrollback') {
    return theme.palette.primary.main;
  }

  return 'green';
}

// Helper function to get status display text
function getStatusDisplayText(status) {
  switch (status) {
    case 'Process':
    case 'inProgress':
      return 'In Progress';
    case 'pendingApproval':
      return 'Pending Approval';
    case 'pendingRollback':
      return 'Pending Rollback';
    case 'open':
      return 'Open';
    case 'closed':
      return 'Closed';
    default:
      return status;
  }
}

// Helper functions moved to outer scope for better performance
function handleClickLang(lang) {
  i18next.changeLanguage(lang);
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function UserPage() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get('id');
  const [open, setOpen] = useState(null);
  const [page, setPage] = useState(0);
  const [total, settotal] = useState(1);
  const [order, setOrder] = useState('desc');
  const [status, setstatus] = useState('status=open');
  const [data, setData] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [index, setindex] = useState(id || 0);
  const [ticketResult, setTicketResult] = useState();
  const navigate = useNavigate();
  const [rowNumber, setRownumber] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const handleCloseMenu = () => {
    setOpen(null);
  };

  const theme = useTheme();

  const handleChangePage = (event, newPage) => {
    if (isLoading) return; // Prevent double-click
    setPage(newPage);
    setIsLoading(true);
    fetchInfo(`${globalThis.REACT_APP_API_PURE}alert?page=${newPage + 1}&${status}&limit=${rowsPerPage}&order=desc`)
      .finally(() => setIsLoading(false));
  };

  const handleChangeRowsPerPage = (event) => {
    if (isLoading) return; // Prevent double-click
    setPage(0);
    setRowsPerPage(Number.parseInt(event.target.value, 10));
    setIsLoading(true);
    fetchInfo(
      `${globalThis.REACT_APP_API_PURE}alert?limit=${Number.parseInt(
        event.target.value,
        10
      )}&${status}&page=${1}&order=desc`
    ).finally(() => setIsLoading(false));
  };

  const handleClicker = () => {
    navigate('/dashboard/alertdetail', { replace: true });
  };

  const fetchInfo = useCallback(
    async (url) => {
      try {
        return fetch(url, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${getToken()}` },
        })
          .then((res) => res.json())
          .then((d) => {
            if (d.code === 401) {
              setData([]);
              settotal(0);
            } else {
              setData(d?.data);
              settotal(d?.pageMeta?.totalItems || 0);
              setRownumber(d?.pageMeta?.itemsPerPage * d?.pageMeta?.currentPage - (d?.pageMeta?.itemsPerPage - 1));
            }
          });
      } catch (error) {}
    },
    [data, setData, data?.data, status]
  );
  const fetchInfoTicket = useCallback(
    async (url, event, id) => {
      try {
        return fetch(url, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${getToken()}` },
        })
          .then((res) => res.json())
          .then((d) => {
            event.preventDefault();
          });
      } catch (error) {}
    },
    [ticketResult, setTicketResult]
  );

  const url2 = `${globalThis.REACT_APP_API_PURE}reference/list?kode=F003`;

  const fetchInfo2 = () =>
    fetch(url2, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${getToken()}` },
    })
      .then((res) => res.json())
      .then((d) => {});
  useEffect(() => {
    fetchInfo2();
    handleChange('', id || 0);
  }, []);

  const handleChange = (event, newValue) => {
    if (isLoading) return; // Prevent double-click
    setindex(newValue);
    setPage(0);
    setIsLoading(true);
    let fetchPromise = null;
    if (newValue == 0 && order == 'desc') {
      setstatus('status=open');
      fetchPromise = fetchInfo(
        `${globalThis.REACT_APP_API_PURE}alert?` + `status=open` + `&limit=${rowsPerPage}&page=${1}&order=desc`
      );
    } else if (newValue == 1 && order == 'desc') {
      setData([]);
      setstatus('status=inProgress');
      fetchPromise = fetchInfo(
        `${globalThis.REACT_APP_API_PURE}alert?` + `status=inProgress` + `&limit=${rowsPerPage}&page=${1}&order=desc`
      );
    } else if (newValue == 2 && order == 'desc') {
      setData([]);
      setstatus('status=pendingApproval');
      fetchPromise = fetchInfo(
        `${globalThis.REACT_APP_API_PURE}alert?` +
          `status=pendingApproval` +
          `&limit=${rowsPerPage}&page=${1}&order=desc`
      );
    } else if (newValue == 3 && order == 'desc') {
      setData([]);
      setstatus('status=pendingRollback');
      fetchPromise = fetchInfo(
        `${globalThis.REACT_APP_API_PURE}alert?` +
          `status=pendingRollback` +
          `&limit=${rowsPerPage}&page=${1}&order=desc`
      );
    } else if (newValue == 4 && order == 'desc') {
      setData([]);
      setstatus('status=closed');
      fetchPromise = fetchInfo(
        `${globalThis.REACT_APP_API_PURE}alert?` + `status=closed` + `&limit=${rowsPerPage}&page=${1}&order=desc`
      );
    } else if (newValue == 0 && order == 'asc') {
      setData([]);
      setstatus('status=open');
      fetchPromise = fetchInfo(`${globalThis.REACT_APP_API_PURE}alert?` + `status=open` + `&limit=${rowsPerPage}&page=${1}&order=asc`);
    } else if (newValue == 1 && order == 'asc') {
      setData([]);
      setstatus('status=inProgress');
      fetchPromise = fetchInfo(
        `${globalThis.REACT_APP_API_PURE}alert?` + `status=inProgress` + `&limit=${rowsPerPage}&page=${1}&order=asc`
      );
    } else if (newValue == 2 && order == 'asc') {
      setData([]);
      setstatus('status=pendingApproval');
      fetchPromise = fetchInfo(
        `${globalThis.REACT_APP_API_PURE}alert?` +
          `status=pendingApproval` +
          `&limit=${rowsPerPage}&page=${1}&order=asc`
      );
    } else if (newValue == 3 && order == 'asc') {
      setData([]);
      setstatus('status=pendingRollback');
      fetchPromise = fetchInfo(
        `${globalThis.REACT_APP_API_PURE}alert?` +
          `status=pendingRollback` +
          `&limit=${rowsPerPage}&page=${1}&order=asc`
      );
    } else if (newValue == 4 && order == 'asc') {
      setData([]);
      setstatus('status=closed');
      fetchPromise = fetchInfo(
        `${globalThis.REACT_APP_API_PURE}alert?` + `status=closed` + `&limit=${rowsPerPage}&page=${1}&order=asc`
      );
    }
    if (fetchPromise) {
      fetchPromise.finally(() => setIsLoading(false));
    } else {
      setIsLoading(false);
    }
  };

  // Dynamic font size calculation function with advanced features
  const getDynamicFontSize = (text, maxSize = 14, minSize = 10, options = {}) => {
    if (!text) return `${maxSize}px`;

    const {
      breakpoints = [10, 20, 30, 50], // Character count breakpoints
      sizeReductions = [0, 1, 2, 3, 4], // Font size reductions at each breakpoint
      responsive = true, // Enable responsive scaling
      containerWidth = 300, // Container width for responsive calculation
    } = options;

    const textLength = text.length;
    let calculatedSize = maxSize;

    // Find the appropriate breakpoint and apply reduction
    for (let i = 0; i < breakpoints.length; i++) {
      if (textLength > breakpoints[i]) {
        calculatedSize = maxSize - (sizeReductions[i + 1] || sizeReductions.at(-1));
      }
    }

    // Responsive scaling based on container width
    if (responsive && containerWidth) {
      const widthFactor = Math.min(containerWidth / 300, 1.2); // Reduced scaling factor
      calculatedSize = calculatedSize * widthFactor;
    }

    // Ensure size is within bounds
    calculatedSize = Math.max(Math.min(calculatedSize, maxSize), minSize);

    return `${Math.round(calculatedSize)}px`;
  };

  // Calculate consistent header font size based on the longest header text
  const getHeaderFontSize = () => {
    const headerTexts = [
      t('Nomor.1'),
      t('AlertId.1'),
      'File Name',
      t('Dataset.1'),
      t('NumberOf.1'),
      t('DateTime.1'),
      'Status',
      t('Aksi.1'),
    ];

    // Find the longest header text
    const longestHeader = headerTexts.reduce(
      (longest, current) => (current.length > longest.length ? current : longest),
      ''
    );

    // Calculate font size based on the longest header
    return getDynamicFontSize(longestHeader, 15, 12, {
      breakpoints: [8, 15, 25, 35],
      sizeReductions: [0, 1, 2, 3, 4],
      containerWidth: 300,
    });
  };

  const StyledTableCell = styled(TableCell, {
    shouldForwardProp: (prop) => prop !== '$dynamicFontSize',
  })(({ theme, $dynamicFontSize }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.common.white,
      fontSize: getHeaderFontSize(), // Dynamic header font size
      fontWeight: 'bold',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      padding: '12px 16px', // Increased padding
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: $dynamicFontSize || '13px', // Increased default font size
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      padding: '10px 16px', // Increased padding
    },
  }));

  const { t } = useTranslation();

  function SearchAndTittle() {
    return (
      <Grid container direction="row" justifyContent={'space-between'} style={{ marginBottom: 20 }}>
        <Grid item alignSelf={'center'}>
          <Typography variant="h5">Alert</Typography>
        </Grid>
        <Grid item>
          {' '}
          <TextField
            placeholder={t('Search.7')}
            variant="outlined"
            size="small"
            fullWidth
            onChange={(e) => {
              if (e.target.value === '') {
                fetchInfo(
                  `${globalThis.REACT_APP_API_PURE}alert?${status}&limit=${rowsPerPage}&page=${page + 1}&order=desc`
                );
              } else fetchInfo(`${globalThis.REACT_APP_API_PURE}alert?q=${e.target.value}&${status}&order=desc`);
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
      </Grid>
    );
  }
  CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };

  const onClick = ({ key }) => {
    if (key === '1') {
      setData([]);
      setOrder('asc');
      fetchInfo(`${globalThis.REACT_APP_API_PURE}alert?${status}&limit=${rowsPerPage}&page=${page + 1}&order=asc`);
    } else if (key === '2') {
      setData([]);
      setOrder('desc');
      fetchInfo(`${globalThis.REACT_APP_API_PURE}alert?${status}&limit=${rowsPerPage}&page=${page + 1}&order=desc`);
    }
  };

  const items = [
    {
      key: '1',
      label: <a>Latest</a>,
    },
    {
      key: '2',
      label: <a>Recent</a>,
    },
  ];

  const [showProgress, setShowProgress] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowProgress(false);
    }, 4000);

    return () => clearTimeout(timer);
  }, [showProgress]);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  return (
    <>
      <Helmet>
        <title> Alert Management | COVAS </title>
      </Helmet>
      <Container>
        {SearchAndTittle()}
        <Grid container direction={'row'}>
          <Grid item xs={12} container direction={'row'}>
            <Tabs value={index} onChange={handleChange} aria-label="basic tabs example">
              <Tab label="Open" {...a11yProps(0)} />
              <Tab label="In Progress" {...a11yProps(1)} />
              <Tab label="Pending Approval" {...a11yProps(2)} />
              <Tab label="Pending Rollback" {...a11yProps(3)} />
              <Tab label="Closed" {...a11yProps(4)} />
            </Tabs>
          </Grid>
          <Grid item xs={12}>
            {' '}
            <Scrollbar>
              <TableContainer sx={{ minWidth: 800, borderRadius: 2, border: '1px solid #e0e0e0' }}>
                <Table>
                  <TableHead>
                    <TableRow className="custom-table-row">
                      <StyledTableCell
                        style={{
                          backgroundColor: '#E2F5FC',
                          color: '#0E7496',
                          fontSize: getHeaderFontSize(),
                          fontWeight: 'bold',
                        }}
                      >
                        {t('Nomor.1')}
                      </StyledTableCell>
                      <StyledTableCell
                        style={{
                          backgroundColor: '#E2F5FC',
                          color: '#0E7496',
                          fontSize: getHeaderFontSize(),
                          fontWeight: 'bold',
                        }}
                      >
                        {t('AlertId.1')}
                      </StyledTableCell>
                      <StyledTableCell
                        style={{
                          backgroundColor: '#E2F5FC',
                          color: '#0E7496',
                          fontSize: getHeaderFontSize(),
                          fontWeight: 'bold',
                        }}
                      >
                        File Name
                      </StyledTableCell>

                      <StyledTableCell
                        style={{
                          backgroundColor: '#E2F5FC',
                          color: '#0E7496',
                          fontSize: getHeaderFontSize(),
                          fontWeight: 'bold',
                        }}
                      >
                        {t('Dataset.1')}
                      </StyledTableCell>
                      <StyledTableCell
                        style={{
                          backgroundColor: '#E2F5FC',
                          color: '#0E7496',
                          fontSize: getHeaderFontSize(),
                          fontWeight: 'bold',
                          textAlign: 'center',
                          lineHeight: 1.2,
                        }}
                      >
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                          <div>Number Of</div>
                          <div>Changes</div>
                        </div>
                      </StyledTableCell>
                      <StyledTableCell
                        style={{
                          backgroundColor: '#E2F5FC',
                          color: '#0E7496',
                          fontSize: getHeaderFontSize(),
                          fontWeight: 'bold',
                          textAlign: 'center',
                          lineHeight: 1.2,
                        }}
                      >
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                          <div>Date & Time</div>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                            <span>Sort</span>
                            <Dropdown
                              menu={{
                                items,
                                onClick,
                                selectable: true,
                              }}
                            >
                              <button
                                type="button"
                                aria-label="Sort options"
                                onClick={(e) => e.preventDefault()}
                                style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
                              >
                                <Space>
                                  <DownOutlined />
                                </Space>
                              </button>
                            </Dropdown>
                          </div>
                        </div>
                      </StyledTableCell>
                      <StyledTableCell
                        style={{
                          backgroundColor: '#E2F5FC',
                          color: '#0E7496',
                          fontSize: getHeaderFontSize(),
                          fontWeight: 'bold',
                        }}
                      >
                        Status
                      </StyledTableCell>
                      <StyledTableCell
                        style={{
                          backgroundColor: '#E2F5FC',
                          color: '#0E7496',
                          fontSize: getHeaderFontSize(),
                          fontWeight: 'bold',
                        }}
                      >
                        {t('Aksi.1')}
                      </StyledTableCell>
                    </TableRow>
                  </TableHead>
                  {loading ? (
                    <TableBody>
                      <TableRow>
                        <TableCell colSpan={12} style={{ textAlign: 'center' }}>
                          <CircularProgress />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  ) : data?.length > 0 ? (
                    <TableBody>
                      {data?.map((index, row, dataObj) => {
                        const date = new Date(index.createdAt);
                        const formattedDate = date
                          .toLocaleString('id-ID', {
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit',
                            hour: '2-digit',
                            minute: '2-digit',
                            hour12: false,
                          })
                          .replace(/\//g, '-');

                        const totalChanges = (index.authorizedCount || 0) + (index.unauthorizedCount || 0);

                        const json = JSON.stringify({
                          id: index.id,
                          recordId: index.recordId,
                          recordName: index.recordName,
                          dataSet: index.dataSet,
                          totalChanges,
                          folder: index.folder,
                          status: index.status,
                          createdAt: formattedDate,

                          closedStatus: index.closedStatus,
                          number: totalChanges,
                          total: {
                            authorized: index.authorizedCount || 0,
                            unauthorized: index.unauthorizedCount || 0,
                          },
                        });
                        const encodedJson = btoa(json);

                        return (
                          <TableRow hover key={row}>
                            <StyledTableCell
                              component="th"
                              scope="row"
                              $dynamicFontSize={getDynamicFontSize(String(rowNumber + row), 13, 10)}
                            >
                              {rowNumber + row}
                            </StyledTableCell>
                            <StyledTableCell
                              component="th"
                              scope="row"
                              padding="none"
                              style={{ maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis' }}
                              $dynamicFontSize={getDynamicFontSize(index.id, 12, 9)}
                            >
                              {index.id}
                            </StyledTableCell>
                            <StyledTableCell
                              component="th"
                              scope="row"
                              padding="none"
                              style={{ maxWidth: '300px', overflow: 'hidden', textOverflow: 'ellipsis' }}
                              $dynamicFontSize={getDynamicFontSize(index.recordName, 13, 10, {
                                breakpoints: [15, 25, 35, 50],
                                sizeReductions: [0, 1, 2, 3, 4],
                                containerWidth: 300,
                              })}
                            >
                              {index.recordName}
                            </StyledTableCell>
                            <StyledTableCell
                              component="th"
                              scope="row"
                              padding="none"
                              style={{ maxWidth: '100px', overflow: 'hidden', textOverflow: 'ellipsis' }}
                              $dynamicFontSize={getDynamicFontSize(index.dataSet, 13, 10)}
                            >
                              <Typography variant="body2" sx={{ paddingLeft: 2 }}>
                                {index.dataSet}
                              </Typography>
                            </StyledTableCell>
                            <StyledTableCell
                              component="th"
                              scope="row"
                              padding="none"
                              style={{ maxWidth: '80px', overflow: 'center', textOverflow: 'ellipsis' }}
                              $dynamicFontSize={getDynamicFontSize(String(totalChanges), 13, 10)}
                            >
                              <Typography variant="body2" sx={{ fontWeight: 600, textAlign: 'center' }}>
                                {totalChanges}
                              </Typography>
                            </StyledTableCell>
                            <StyledTableCell
                              component="th"
                              scope="row"
                              padding="none"
                              style={{
                                maxWidth: '100px',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                textAlign: 'center',
                              }}
                              $dynamicFontSize={getDynamicFontSize(formattedDate, 13, 10)}
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  alignItems: 'center',
                                  lineHeight: 1.2,
                                }}
                              >
                                <div>{formattedDate.split(', ')[0]}</div>
                                <div>{formattedDate.split(', ')[1]}</div>
                              </div>
                            </StyledTableCell>
                            <StyledTableCell
                              component="th"
                              scope="row"
                              padding="none"
                              $dynamicFontSize={getDynamicFontSize(getStatusDisplayText(index.status), 13, 10)}
                            >
                              <span
                                style={{
                                  backgroundColor: getStatusBackgroundColor(index.status, theme),
                                  fontSize: getDynamicFontSize(getStatusDisplayText(index.status), 14, 11),
                                  marginLeft: 20,
                                  color: 'white',
                                  borderRadius: 10,
                                  display: 'inline-flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  width: 150,
                                }}
                              >
                                {getStatusDisplayText(index.status)}
                              </span>
                            </StyledTableCell>

                            <StyledTableCell $dynamicFontSize={getDynamicFontSize('View Details', 13, 10)}>
                              <Link
                                to={{
                                  pathname: `/dashboard/alert/detail-alert`,
                                  search: `?id=${encodedJson}`,
                                }}
                                onClick={(event) => {
                                  if (index.status === 'open') {
                                    fetchInfoTicket(
                                      `${globalThis.REACT_APP_API_PURE}ticket/check?alert_id=${index.id}`,
                                      event,
                                      index.id
                                    );
                                  }
                                }}
                                style={{
                                  textDecoration: 'none',
                                  borderRadius: '20px',
                                  border: '1px solid #12A2CE',
                                  padding: '6px 16px',
                                  color: '#12A2CE',
                                  display: 'inline-block',
                                  textAlign: 'center',
                                  cursor: 'pointer',
                                }}
                              >
                                {t('Detail.1')}
                              </Link>
                            </StyledTableCell>
                          </TableRow>
                        );
                      })}
                      {}
                    </TableBody>
                  ) : (
                    <TableRow>
                      <TableCell colSpan={12} style={{ textAlign: 'center', alignContent: 'center' }}>
                        <Empty />
                      </TableCell>
                    </TableRow>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>
          </Grid>
        </Grid>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={total}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Container>
      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{
          paper: {
            sx: {
              p: 1,
              width: 140,
              '& .MuiMenuItem-root': {
                px: 1,
                typography: 'body2',
                borderRadius: 0.75,
              },
            },
          },
        }}
      >
        <MenuItem onClick={handleClicker}>
          <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
          Process
        </MenuItem>
      </Popover>
    </>
  );
}
